<script setup lang="ts">
import type { ICustomField } from '@nova/core';

/**
 * Label component for custom fields.
 * Displays field label with optional required indicator.
 */
const {
  field,
  htmlFor,
  required = false
} = defineProps<{
  field: ICustomField;
  required?: boolean;
  htmlFor?: string;
}>();
</script>

<template>
  <label class="d-flex flex-row align-center ga-1" :for="htmlFor">
    <span class="typography-body-sm-bold text--color-text-primary">{{ field.label }}</span>
    <span v-if="required" class="custom-field-label__required text--color-text-error">*</span>
    <slot name="append"></slot>
  </label>
</template>
